import {useState} from 'react'
import {Users, Plus} from 'lucide-react'
import {useApp} from '../../context/AppContext'
import type {Team} from '../../types'
import TeamCard from './TeamCard'
import TeamForm from './TeamForm'
import ConfirmDialog from '../common/ConfirmDialog'
import PageHeader from '../common/PageHeader'

export default function TeamList() {
  const {state, apiDeleteTeam} = useApp()
  const [showForm, setShowForm] = useState(false)
  const [editTeam, setEditTeam] = useState<Team | undefined>(undefined)
  const [deleteTeamId, setDeleteTeamId] = useState<string | null>(null)

  const handleEdit = (team: Team) => {
    setEditTeam(team)
    setShowForm(true)
  }

  const handleDelete = (teamId: string) => {
    setDeleteTeamId(teamId)
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setEditTeam(undefined)
  }

  return (
    <div className='devops-page'>
      <PageHeader
        eyebrow='Organização'
        icon={Users}
        title='Equipes'
        description='Estruture os times, defina lideranças e acompanhe a capacidade de entrega de cada grupo.'
        meta={
          <span>
            {state.teams.length}{' '}
            {state.teams.length === 1 ? 'equipe cadastrada' : 'equipes cadastradas'}
          </span>
        }
        actions={
          <button onClick={() => setShowForm(true)} className='devops-primary-button'>
            <Plus size={16} />
            Nova equipe
          </button>
        }
      />

      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4'>
        {state.teams.length === 0 && (
          <div className='devops-empty-state col-span-full'>
            <div>
              <Users size={28} className='mx-auto' />
              <p className='text-sm font-medium text-slate-600'>Nenhuma equipe cadastrada</p>
              <p className='mt-1 text-xs'>Crie a primeira equipe para organizar as entregas.</p>
            </div>
          </div>
        )}
        {state.teams.map((team, index) => (
          <div
            key={team.id}
            className='animate-slide-in-up'
            style={{animationDelay: `${index * 80}ms`}}
          >
            <TeamCard
              team={team}
              onEdit={() => handleEdit(team)}
              onDelete={() => handleDelete(team.id)}
            />
          </div>
        ))}
      </div>

      {showForm && <TeamForm team={editTeam} onClose={handleCloseForm} />}

      <ConfirmDialog
        isOpen={deleteTeamId !== null}
        title='Excluir equipe'
        message='Tem certeza que deseja excluir esta equipe? Esta ação não pode ser desfeita.'
        confirmLabel='Excluir'
        onConfirm={() => {
          if (deleteTeamId) apiDeleteTeam(deleteTeamId)
          setDeleteTeamId(null)
        }}
        onCancel={() => setDeleteTeamId(null)}
      />
    </div>
  )
}
